import type { CSSProperties } from 'react';
import { useMediaQuery } from '@mantine/hooks';

export const MOBILE_LAYOUT_BREAKPOINT = '(max-width: 768px)';

export function useIsMobileLayout(): boolean {
  return useMediaQuery(MOBILE_LAYOUT_BREAKPOINT) ?? false;
}

export function pageTableShellStyle(isMobile: boolean): CSSProperties {
  return {
    border: '1px solid #ddd',
    borderRadius: '5px',
    overflow: isMobile ? 'visible' : 'hidden',
  };
}

export function mrtTableContainerStyle(isMobile: boolean): CSSProperties {
  if (isMobile) {
    return {
      maxHeight: '65vh',
      overflowY: 'auto',
      overflowX: 'auto',
    };
  }

  return {
    maxHeight: 'calc(100vh - 280px)',
    overflowY: 'auto',
    overflowX: 'auto',
  };
}

export function pageScrollPanelStyle(isMobile: boolean, maxHeight: string): CSSProperties {
  if (isMobile) {
    return {
      overflow: 'visible',
      width: 'max-content',
      minWidth: '100%',
    };
  }

  return {
    maxHeight,
    overflowY: 'auto',
  };
}

export function usePageTableShellStyle(): CSSProperties {
  const isMobile = useIsMobileLayout();
  return pageTableShellStyle(isMobile);
}

export function useMrtTableContainerProps(): { style: CSSProperties } {
  const isMobile = useIsMobileLayout();
  return { style: mrtTableContainerStyle(isMobile) };
}

export function usePageScrollPanelStyle(maxHeight: string): CSSProperties {
  const isMobile = useIsMobileLayout();
  return pageScrollPanelStyle(isMobile, maxHeight);
}

export const MODAL_SCROLL_AREA_HEIGHT_DESKTOP = '75vh';

export const MODAL_SCROLL_AREA_HEIGHT_MOBILE =
  'calc(100dvh - 9rem - env(safe-area-inset-top, 0px))';

export function modalScrollAreaHeight(isMobile: boolean): string {
  return isMobile ? MODAL_SCROLL_AREA_HEIGHT_MOBILE : MODAL_SCROLL_AREA_HEIGHT_DESKTOP;
}

export function useModalScrollAreaHeight(): string {
  const isMobile = useIsMobileLayout();
  return modalScrollAreaHeight(isMobile);
}
